export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <img alt="" src="img/logo.png" style={{ width: "10%" }} />
                <h2 style={{ color: "white", fontFamily: "cursive" }}>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h2>
                {/* <p>{props.data ? props.data.paragraph : "Loading"}</p> */}
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
